import { matchPath, useLocation } from "react-router-dom";
import { setlandingPage } from "../store/MahutiReducer";




export const CheckInternal = (location) => {


    if (location.pathname.match('[*internal*]')) {
        console.log('internal exist');
        // dispatch(setlandingPage({internal: true}))

        return {internal: true}
    }
    return {internal: false}
}

export const HeaderName = () => {
    const location = useLocation();
    if(location.pathname === '/activity') return 'הי אני עמוד נחיתה';
    else return 'בואו לבחור את הפעילות שמתאימה לכם';
}


export const HeaderItems = () => {
    const location = useLocation();
    if(location.pathname === '/') return null;
    if(location.pathname === '/activity/' || location.pathname === '/activity') return <button className="btn-primary m-1 card-title-light" type="submit">תאום פעילות ורכישת כרטיסים</button>;
    // if(location.pathname === '/schedual/' || location.pathname === '/schedual') return <button className="btn-primary m-1" type="submit">רכישת כרטיסים</button>;

}
export const discount_message = "5% הנחה במעמד הרכישה למחזיקי הכרטיסים הבאים: מועדון נכון | עובדי המדינה אשמורת | הסתדרות המורים | ישרכארט פלוס הוט | מהנדסי לאומי קארד | ביחד בשבילך | בהצדעה | הנחות פלוס | לאומי קארד מקס קרנות";